import { Realty } from '@ambita/ambita-components-core';
import { ApiSection } from '../../../typings/CadastreReport';

function transformSectionings(sectionData: Realty.ApiResponse) {
  if (sectionData.items && sectionData.items.length > 0) {
    const sections: ApiSection[] = sectionData.items;
    const retObject: any = {
      sectioned: false
    };

    if (sections.length === 1) {
      retObject.purposeSectioning = sections[0].purposeSectioning;
      retObject.ownerShare = `${sections[0].numerator} / ${sections[0].denominator}`;
      retObject.sectioned = true;
    } else if (sections.length > 1) {
      const resultObject = sections.reduce((previousValue, currentValue) => {
        if (previousValue.ident.serialNumber > currentValue.ident.serialNumber) {
          return previousValue;
        } else {
          return currentValue;
        }
      });

      retObject.purposeSectioning = resultObject.purposeSectioning;
      retObject.ownerShare = `${resultObject.numerator} / ${resultObject.denominator}`;
      retObject.sectioned = true;
    }
    return retObject;
  }
}

export default transformSectionings;
